import { fetchWithAuth } from "../utils/fetchWithAuth";


export async function generatePoliteMessage({ purpose, inputText, tone, length, emoji }) {
  const token = localStorage.getItem('token');
  const anonId = localStorage.getItem('anon_id');
  const response = await fetchWithAuth(`/generate`, {
    method: 'POST',
    headers: {
      "X-Anonymous-ID": !token && anonId ? anonId : ""
    },
    body: JSON.stringify({
      purpose,
      input: inputText,
      tone,
      length,
      emoji,
    }),
  });

  if (response.status === 429) {
    throw new Error("429: Too many requests");
  }

  if (!response.ok) {
    throw new Error(`서버 오류: ${response.status}`);
  }

  const data = await response.json();
  return data.result;
}
